module.exports = __webpack_public_path__ + "img/Fetu_o_Siva_Polynesian_Dance_Academy_thumbnail.51b51154.png";